import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import { ClassAttributes, HTMLAttributes } from "react";

import { Tilerail } from "./Tilerail";

export const TilerailBanner = ({
    className,
    ...props
}: ClassAttributes<HTMLDivElement> &
    HTMLAttributes<HTMLDivElement> & {
        className?: string;
    }) => {
    return (
        <div
            className={cn(
                "relative flex h-[88px] w-full select-none items-center overflow-hidden rounded-xl bg-grey-100",
                className
            )}
            {...props}
        >
            <div className="absolute bottom-0 right-[18%] top-0 hidden lg:flex [&>*:not(:last-child)]:mr-2">
                <Tilerail
                    direction={1}
                    items={[
                        "/img/tile_1.png",
                        "/img/tile_2.png",
                        "/img/tile_3.png",
                        "/img/tile_4.png",
                        "/img/tile_5.png"
                    ]}
                    edge={80}
                    duration={15}
                    height={160}
                    gap={8}
                />
                <Tilerail
                    direction={-1}
                    items={[
                        "/img/tile_6.png",
                        "/img/tile_7.png",
                        "/img/tile_8.png",
                        "/img/tile_9.png",
                        "/img/tile_10.png"
                    ]}
                    edge={80}
                    duration={15}
                    height={160}
                    gap={8}
                />
                <Tilerail
                    direction={1}
                    items={[
                        "/img/tile_11.png",
                        "/img/tile_12.png",
                        "/img/tile_13.png",
                        "/img/tile_14.png",
                        "/img/tile_15.png"
                    ]}
                    edge={80}
                    duration={15}
                    height={160}
                    gap={8}
                />
            </div>
            <div className="absolute bottom-0 right-[10%] top-0 hidden md:flex lg:hidden [&>*:not(:last-child)]:mr-2">
                <Tilerail
                    direction={1}
                    items={[
                        "/img/tile_1.png",
                        "/img/tile_2.png",
                        "/img/tile_3.png",
                        "/img/tile_4.png",
                        "/img/tile_5.png"
                    ]}
                    edge={64}
                    duration={15}
                    height={173}
                    gap={8}
                />
                <Tilerail
                    direction={-1}
                    items={[
                        "/img/tile_6.png",
                        "/img/tile_7.png",
                        "/img/tile_8.png",
                        "/img/tile_9.png",
                        "/img/tile_10.png"
                    ]}
                    edge={64}
                    duration={15}
                    height={173}
                    gap={8}
                />
                <Tilerail
                    direction={1}
                    items={[
                        "/img/tile_11.png",
                        "/img/tile_12.png",
                        "/img/tile_13.png",
                        "/img/tile_14.png",
                        "/img/tile_15.png"
                    ]}
                    edge={64}
                    duration={15}
                    height={173}
                    gap={8}
                />
            </div>
            <div className="absolute bottom-0 right-6 top-0 flex md:hidden [&>*:not(:last-child)]:mr-2">
                <Tilerail
                    direction={1}
                    items={[
                        "/img/tile_1.png",
                        "/img/tile_2.png",
                        "/img/tile_3.png",
                        "/img/tile_4.png",
                        "/img/tile_5.png",
                        "/img/tile_6.png",
                        "/img/tile_7.png",
                        "/img/tile_8.png",
                        "/img/tile_9.png",
                        "/img/tile_10.png",
                        "/img/tile_11.png",
                        "/img/tile_12.png",
                        "/img/tile_13.png",
                        "/img/tile_14.png",
                        "/img/tile_15.png"
                    ]}
                    edge={56}
                    duration={20}
                    height={130}
                    gap={8}
                />
            </div>
            <div className="absolute z-[1] ml-5 flex h-full flex-col items-start justify-center gap-2 rounded-xl dark:bg-transparent md:px-6">
                <Text
                    className="md:text-body1 whitespace-pre-wrap font-normal"
                    variant="p"
                    tag="h1"
                >
                    마케터에게 필요한 모든 인사이트를 한 곳에
                </Text>
                <Text
                    className="hidden md:block"
                    variant="body3"
                    color="text.disabled"
                    tag="h2"
                >
                    믹스에서 최신 트렌드와 마케팅 인사이트를 발견하세요.
                </Text>
            </div>
        </div>
    );
};
